import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectIsInProgress } from '../../../features/spinner/ducks';
import Spin from 'antd/lib/spin';
import {
  selectPayment,
  fetchPaymentActions,
  assignToCreditorActions,
  refundPaymentActions,
  getAvailableInstallmentActions,
} from '../ducks';
import { fetchAccountActions, selectAccount } from '../../account-management/ducks';
import { apiCallIds } from '../api';
import { PaymentDetail } from '../components';

const mapStateToProps = (state, props) => ({
  payment: selectPayment(state),
  account: selectAccount(state),
  isLoading: selectIsInProgress(state, apiCallIds.FETCH_PAYMENT),
  paymentId: props.params.paymentId,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchPayment: fetchPaymentActions.request,
      assignToCreditor: assignToCreditorActions.request,
      getAvailableInstallment: getAvailableInstallmentActions.request,
      refundPayment: refundPaymentActions.request,
      fetchAccount: fetchAccountActions.request,
    },
    dispatch
  ),
});

@connect(mapStateToProps, mapDispatchToProps)
export default class PaymentDetailContainer extends Component {
  static propTypes = {
    payment: PropTypes.object,
    isLoading: PropTypes.bool.isRequired,
    paymentId: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount() {
    
    const { paymentId, actions } = this.props;
    actions.fetchPayment({ paymentId });

  }

  onAssignToCreditor = accountId => {
    const { paymentId, actions } = this.props;
    actions.assignToCreditor({ paymentId, accountId });
  };

  onAssignToLoan = loanId => {
    const { paymentId, actions } = this.props;
    actions.getAvailableInstallment({ paymentId, loanId });
  };

  onRefundPayment = () => {
    const { paymentId, actions } = this.props;
    actions.refundPayment({ paymentId });
  };

  render() {
    const { payment, isLoading, actions, account} = this.props;

    if (!payment) {
      return (
        <Spin spinning={isLoading}>
          <div className="spin-empty-content" />
        </Spin>
      );
    }

    return (
      <Spin spinning={isLoading }>
        <PaymentDetail
          payment={payment}
          onAssignToCreditor={this.onAssignToCreditor}
          onAssignToLoan={this.onAssignToLoan}
          onRefundPayment={this.onRefundPayment}
          onDivingPayment={this.onDivingPayment}
        />
      </Spin>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/payment-management/containers/PaymentDetailContainer.js